import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    CargoCol,
    CargoHeaderField,
    CargoHeaderFieldsWrapper,
    CargoHeaderRowGroup,
    CargoHeaderRowGroupsWrapper,
    CargoTankHeaderRow,
} from './CargoTempLogReporting.style';
import { SortColumnEnum } from '../CargoTemperatureLogUtils';

type CargoLogTableHeaderProps = {
    sortColumn: SortColumnEnum;
    sortDesc: boolean;
    changeSort: (column: SortColumnEnum) => void;
    activeLogSchedules: string[];
    isCommentsVisible: boolean;
    cargoTemperatureInputFields: any[];
};

const CargoLogTableHeader: React.FC<CargoLogTableHeaderProps> = ({
    sortColumn,
    sortDesc,
    changeSort,
    activeLogSchedules,
    isCommentsVisible,
    cargoTemperatureInputFields,
}) => {
    return (
        <CargoTankHeaderRow numberOfFields={0}>
            <CargoCol className="header cargo-nr" onClick={() => changeSort(SortColumnEnum.CargoNr)}>
                Cargo nr
                {sortColumn === SortColumnEnum.CargoNr && (
                    <span>
                        {' '}
                        <FontAwesomeIcon
                            className="sort-icon"
                            title="Click to change sorting"
                            icon={sortDesc && sortColumn === SortColumnEnum.CargoNr ? 'arrow-up' : 'arrow-down'}
                        />
                    </span>
                )}
            </CargoCol>
            <CargoCol className="header trade-name" onClick={() => changeSort(SortColumnEnum.TradeName)}>
                Trade name
                {sortColumn === SortColumnEnum.TradeName && (
                    <span>
                        {' '}
                        <FontAwesomeIcon
                            className="sort-icon"
                            title="Click to change sorting"
                            icon={sortDesc && sortColumn === SortColumnEnum.TradeName ? 'arrow-up' : 'arrow-down'}
                        />
                    </span>
                )}
            </CargoCol>
            <CargoCol className="header tank-name" onClick={() => changeSort(SortColumnEnum.Tank)}>
                Tank
                {sortColumn === SortColumnEnum.Tank && (
                    <span>
                        {' '}
                        <FontAwesomeIcon
                            className="sort-icon"
                            title="Click to change sorting"
                            icon={sortDesc && sortColumn === SortColumnEnum.Tank ? 'arrow-up' : 'arrow-down'}
                        />
                    </span>
                )}
            </CargoCol>
            <CargoCol className="header category" onClick={() => changeSort(SortColumnEnum.Category)}>
                Category
                {sortColumn === SortColumnEnum.Category && (
                    <span>
                        {' '}
                        <FontAwesomeIcon
                            className="sort-icon"
                            title="Click to change sorting"
                            icon={sortDesc && sortColumn === SortColumnEnum.Category ? 'arrow-up' : 'arrow-down'}
                        />
                    </span>
                )}
            </CargoCol>
            <CargoCol className="header unit">O2 unit</CargoCol>
            <CargoCol className="header fields">
                <CargoHeaderRowGroupsWrapper>
                    {activeLogSchedules.map((logTime, i) => (
                        <CargoHeaderRowGroup showComments={isCommentsVisible} key={`cargo_header_tank${logTime}_${i}`}>
                            <div className="log-time">{logTime}</div>
                            <CargoHeaderFieldsWrapper>
                                <CargoHeaderField key={`fieldName_${i}_onBoard`}>On board</CargoHeaderField>
                                {cargoTemperatureInputFields
                                    .filter((x) => x.fieldName !== 'Comment' || isCommentsVisible)
                                    .map((field, j) => (
                                        <CargoHeaderField
                                            key={`fieldName_${field.fieldName}_${i}_${j}`}
                                            className={field.cargoTemperatureInputFieldId === 2 ? 'unit-col' : ''}
                                        >
                                            {field.fieldName}
                                        </CargoHeaderField>
                                    ))}
                            </CargoHeaderFieldsWrapper>
                        </CargoHeaderRowGroup>
                    ))}
                </CargoHeaderRowGroupsWrapper>
            </CargoCol>
        </CargoTankHeaderRow>
    );
};

export default CargoLogTableHeader;
